import * as React from 'react'
import { defineMessages, FormattedHTMLMessage } from 'react-intl'
import Form from './form'
import styles from './hero.module.scss'

const messages = defineMessages({
  heading: {
    defaultMessage: `Med Dooer är det enkelt
och roligt att driva eget`,
    id: 'consultant.hero.heading',
  },
  lede: {
    defaultMessage:
      'Välkommen till ditt nya liv som Dooer-kund. Ingen mer stress och oro kring tråkig administration, nu har du istället din personliga seniora ekonom som jobbar tillsammans med dig. Tillsammans är ni ett team där ekonomen gör allt som du tycker är tråkigt, så du kan fokusera på det du tycker är roligt 😃',
    id: 'consultant.hero.lede',
  },
  formTitle: {
    defaultMessage: 'Få en gratis offert!',
    id: 'consultant.hero.formTitle',
  },
})

export default function Hero() {
  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        <div className={styles.text}>
          <FormattedHTMLMessage tagName="h1" {...messages.heading} />
          <FormattedHTMLMessage tagName="p" {...messages.lede} />
        </div>
        <div className={styles.formWrapper}>
          <div className={styles.formTitleWrapper}>
            <FormattedHTMLMessage tagName="h4" {...messages.formTitle} />
          </div>
          <Form />
        </div>
      </div>
    </div>
  )
}
